module.exports = __webpack_public_path__ + "static/00096.3bd724a0.jpg";